import React, { useState } from 'react'
import { css } from '@emotion/react'

function Checkbox({ label, value }) {
    const [checked, setChecked] = useState(value)

    const handleChange = () => {
        setChecked(!checked)
    }

    const style = css`
        cursor: pointer;
        .label-text {
            margin: 0 0.5rem;
        }
    `

    return (
        <React.Fragment>
            <label css={style}>
                <input
                    type="checkbox"
                    checked={checked}
                    onChange={handleChange}
                />
                <span className="label-text">{label}</span>
            </label>
        </React.Fragment>
    )
}

export default Checkbox
